export default {
  TitleName: 'Phiếu KCTK, QT',
  DetailName: 'Phiếu kết chuyển tài khoản',
  Object: 'Đối tượng',
  BankAccountTitle: 'TKKB',
  BankAccountTooltip: 'Tài khoản kho bạc',
  AdvancePayment: 'Kết chuyển từ Bảng kê thanh toán tạm ứng: ',
  AdvanceExpence: 'Kết chuyển từ Bảng kê chứng từ thực chi: ',
  ReceiptExpence: 'Kết chuyển từ Bảng kê ghi thu/ghi chi: ',
  AdvanceNSNN: 'Kết chuyển từ Bảng kê nộp tiền NSNN: ',
  TransferBudgetBalance: 'Kết chuyển kết dư sang thu ngân sách xã',
  TranferReceiptClearInMonth13: 'Kết chuyển chênh lệch thu, chi ngân sách xã trong thời gian chỉnh lý',
  TransferBegining: 'Quyết toán dự toán chi ngân sách cuối năm',
  TransferActivity: 'Kết chuyển hoạt động sự nghiệp',
  TranferClosing: 'Kết chuyển cuối năm',
  TranferReceiptClear: 'Kết chuyển chênh lệch thu, chi ngân sách xã',
  TransferExtraBudget: 'Kết chuyển kết dư',
  TranferReceiptClearReceipt: 'Chuyển thu ngân sách',
  TranferReceiptClearExpense: 'Chuyển chi ngân sách',
  WarningMessage: {
    Message: 'Đã có chứng từ kết chuyển số <span class="color-green">{0}</span>. Bạn có muốn xem không?',
  },
  QuickAccountTransfer: 'Kết chuyển nhanh',
  ShowMessageIsEnough: {
    Message:
      'Đã thực hiện đủ các Phiếu kết chuyển tài khoản/Quyết toán. Xem lại chứng từ kết chuyển/quyết toán trên danh sách chứng từ.',
    Title: 'Kết chuyển nhanh',
    Button: 'Đồng ý',
  },
  ShowMessageNoData: {
    Message:
      'Chưa có số liệu để Kết chuyển tài khoản/Quyết toán. Vui lòng thực hiện các chứng từ trong năm, sau đó thực hiện kết chuyển tài khoản/Quyết toán sau.',
    Title: 'Kết chuyển nhanh',
    Button: 'Đồng ý',
  },
  WarningTitle: 'Kết chuyển tài khoản',

  Master: {
    Description: {
      FromCaPayment: 'Sinh phiếu kết chuyển tài khoản từ phiếu chi số {0}',
      FromBaDeposit: 'Sinh phiếu kết chuyển tài khoản từ phiếu nộp tiền kho bạc số {0}',
    },
  },
};
